import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './../../styles/Alert.css';
import { IoAlertCircleSharp } from "react-icons/io5";
import { IoIosClose } from "react-icons/io";

const AlertError = ({ message, onClose }) => {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    // Sound + auto-dismiss once per alert mount. Do not depend on onClose:
    // parents often pass an inline () => ..., which would re-fire on every re-render.
    useEffect(() => {
        const audio = new Audio(process.env.PUBLIC_URL + '/sounds/alertError.mp3');

        audio.play().catch(err => {
            console.warn('Audio could not play:', err);
        });

        const timer = setTimeout(() => {
            onCloseRef.current?.();
        }, 3000);
        return () => {
            clearTimeout(timer);
            audio.pause();
            audio.src = '';
        };
    }, []);

    const alert = (
        <div className="alert-error">
            <div className="alert-header">
                <IoAlertCircleSharp className="alert-icon" />
                <div className="alert-texts">
                    <strong>Error</strong>
                    <span className="alert-message">{message}</span>
                </div>
                <button className="alert-close-btn" onClick={onClose}>
                    <IoIosClose />
                </button>
            </div>
            <div className="alert-timer-bar"></div>
        </div>
    );

    return createPortal(alert, document.body);
};

export default AlertError;
